import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../../../common/http/http-utils';

@Injectable()
export class ResourcePoolService {

    private resourcePoolDetailsApi: String = "/hybridity/api/dps/vc/";

    constructor(public http: HttpClient) {
    }

    getResourcePoolDetails(resourcepoolId: string, vcId: string) {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.resourcePoolDetailsApi + vcId + "/resourcepool/" + resourcepoolId)
        ;
    }

	getDeletedVmDetails(vcenterInstanceId: string, resourcePoolId: string) {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/'
                + vcenterInstanceId + '/resourcepool/' + resourcePoolId + '/deletedVMs')
            ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/resource-pool/resource-pool-details-vc.service.ts